export default "__VITE_ASSET__28c66b1f__"